// hidden error code for the toast message
export enum InternalErrorCode {
  ERR_CS_0041 = 'ERR-CS-0041',
  ERR_CS_0042 = 'ERR-CS-0042',
  ERR_CS_0003 = 'ERR-CS-0003',
  ERR_CS_0034 = 'ERR-CS-0034',
  ERR_PM_1001 = 'ERR-PM-1001',
  ERR_PM_0024 = 'ERR-PM-0024',
}
